exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".specialAttributeDetail__title___3zZHv, .specialAttributeDetail__value___wK1hS {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden; }\n\n.specialAttributeDetail__title___3zZHv {\n  font-weight: 400;\n  font-size: 15px;\n  color: #7f7f7f;\n  line-height: normal;\n  margin-top: 1px;\n  margin-left: 5px; }\n\n.specialAttributeDetail__value___wK1hS {\n  margin-left: 8px;\n  float: right;\n  line-height: normal;\n  color: #000000;\n  font-size: 15px;\n  font-weight: 400;\n  vertical-align: middle; }\n", ""]);

// exports
exports.locals = {
	"title": "specialAttributeDetail__title___3zZHv",
	"value": "specialAttributeDetail__value___wK1hS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/SpecialSectionMobile/SpecialAttributeCard/SpecialAttributeDetail/specialAttributeDetail.scss
// module id = 4418
// module chunks = 6